// export default () => {
//     const sticky = $('.hero-cta')
//     const body = $('body')

//     if(sticky.length != 0) {
//         const clone = sticky.clone()
//         clone.addClass('cta-sticky')
//         body.append(clone)

//         $.fn.visible = function() {
//             var elementTop = $(this).offset().top;
//             var elementBottom = elementTop + $(this).outerHeight();

//             var viewportTop = $(window).scrollTop();
//             var viewportBottom = viewportTop + $(window).height();

//             return elementBottom > viewportTop && elementTop < viewportBottom;
//         };

//         if($('.hero-block').visible()) {
//             clone.addClass('hide')
//         } else {
//             clone.removeClass('hide');
//         }

//         $(window).on('scroll', function () {
//             if($('.hero-block').visible()) {
//                 clone.addClass('hide')
//             } else {
//                 clone.removeClass('hide');
//             }
//         });
//     }
// }


// WEBPACK FOOTER //
// ./scripts/layout/sticky.js